import { render, staticRenderFns } from "./CompanySettingFooter.vue?vue&type=template&id=4f6c65ba&"
import script from "./CompanySettingFooter.vue?vue&type=script&lang=js&"
export * from "./CompanySettingFooter.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports